import { createFileRoute } from '@tanstack/react-router'

import { EditQuotePage } from '@/pages/quotes/[id]/edit/EditQuotePage'

export const Route = createFileRoute('/_authenticated/_dashboard/quotes/$id/edit/')({
  component: EditQuotePage,
})
